import React from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import {
    Users, Download, BarChart3, Shield,
    FileText, Loader2, FileSpreadsheet, ClipboardList
} from 'lucide-react';

const EXPORT_OPTIONS = [
    { type: 'usuarios', title: 'Base de usuarios', desc: 'Emails, estados, progreso, fechas', icon: Users },
    { type: 'progreso', title: 'Progreso por módulo', desc: 'Envíos de módulos, análisis de progreso', icon: BarChart3 },
    { type: 'observaciones', title: 'Observaciones', desc: 'Notas de mentora por módulo', icon: ClipboardList },
    { type: 'feedback', title: 'Feedback de usuarios', desc: 'Calificaciones y comentarios', icon: FileText },
    { type: 'auditoria', title: 'Log de auditoría', desc: 'Acciones del sistema', icon: Shield },
    { type: 'completo', title: 'Exportación completa', desc: 'Todos los datos consolidados', icon: FileSpreadsheet },
];

export default function MentorExportarTab({ handleExport, exporting }) {
    return (
        <>
            <div className="mb-6"><h2 className="text-lg font-semibold text-[#1F2933] font-['Outfit']">Exportar datos</h2><p className="text-sm text-[#616E7C]">Descarga registros estructurados en formato CSV</p></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {EXPORT_OPTIONS.map(exp => (
                    <Card key={exp.type} className="bg-white border-[#EAE8E3] shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="pt-5 pb-4">
                            <div className="flex items-start gap-3">
                                <div className="w-10 h-10 bg-[#3E5F6E]/10 rounded-xl flex items-center justify-center shrink-0"><exp.icon className="h-5 w-5 text-[#3E5F6E]" /></div>
                                <div className="flex-1 min-w-0">
                                    <h3 className="text-sm font-semibold text-[#1F2933]">{exp.title}</h3>
                                    <p className="text-xs text-[#9AA5B1] mb-3">{exp.desc}</p>
                                    <Button size="sm" onClick={() => handleExport(exp.type)} disabled={exporting === exp.type} className="bg-[#3E5F6E] hover:bg-[#2F4A57] text-white" data-testid={`export-${exp.type}`}>
                                        {exporting === exp.type ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" /> : <Download className="h-3.5 w-3.5 mr-1" />}Descargar CSV
                                    </Button>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </>
    );
}
